import 'css-chunksrc/client/scenes/projectReport/indicatorsForm/styles.scss';export default {
  "indicatorsForm": "_indicatorsForm_h43zd_1",
  "input": "_input_h43zd_10",
  "indicator": "_indicator_h43zd_1",
  "name": "_name_h43zd_27"
};